
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { getExchangeLogo } from "../utils/filter-utils";
import { getCampaignCookie } from "@/hooks/referrals/referralUtils";

interface ExchangeFilterProps {
  selectedExchanges: string[];
  onToggle: (exchange: string) => void;
}

const ExchangeFilter = ({ selectedExchanges, onToggle }: ExchangeFilterProps) => {
  const campaignCookie = getCampaignCookie();
  const isPhemexCampaign = campaignCookie === "phemex";
  const isOkxCampaign = campaignCookie === "okx";
  
  // If it's a specific campaign, only show that exchange
  let availableExchanges = ["OKX", "Bybit", "Bitget", "Phemex"];
  
  if (isPhemexCampaign) {
    availableExchanges = ["Phemex"];
  } else if (isOkxCampaign) {
    availableExchanges = ["OKX"];
  }
  
  return (
    <div className="space-y-2">
      <Label className="text-sm font-bold text-[#1B2F47] block mb-2">
        Exchange
      </Label>
      <div className="flex flex-wrap gap-4">
        {availableExchanges.map((exchange) => (
          <div key={exchange} className="flex items-center">
            <Checkbox
              id={`exchange-${exchange}`}
              checked={selectedExchanges.includes(exchange)}
              onCheckedChange={() => onToggle(exchange)}
              className="hidden"
              disabled={(isPhemexCampaign && exchange === "Phemex") || (isOkxCampaign && exchange === "OKX")} // Disable toggling if campaign specific
            />
            <Label
              htmlFor={`exchange-${exchange}`}
              className={`cursor-pointer transition-opacity ${
                selectedExchanges.includes(exchange) ? 'opacity-100' : 'opacity-50'
              } ${(isPhemexCampaign && exchange === "Phemex") || (isOkxCampaign && exchange === "OKX") ? 'cursor-default' : ''}`}
            >
              <img 
                src={getExchangeLogo(exchange)} 
                alt={exchange}
                className="h-6 w-auto" 
              />
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExchangeFilter;
